import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25d64cde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 rounded-3" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_3 = { class: "alert alert-warning text-uppercase fw-bold" }
const _hoisted_4 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  class: "text-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-uppercase fw-bold" }, "Beneficio agotado", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 3,
  class: "text-center"
}
const _hoisted_11 = { class: "text-uppercase fw-bold mb-3" }
const _hoisted_12 = { class: "text-uppercase fw-bold mb-3" }
const _hoisted_13 = { class: "text-uppercase fw-bold mb-3" }
const _hoisted_14 = {
  key: 1,
  class: "text-center"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-uppercase mb-8" }, " Utiliza este código de promoción en tu próxima compra: ", -1))
const _hoisted_16 = { class: "text-uppercase mb-8" }
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "IR A LA TIENDA", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "mb-0 mt-4" }, " * Beneficio aplicable por única vez en tu primera compra aplicando el código de promoción que te brindaremos a continuación ", -1))

import { cuponesService } from '@/services/cupones.service'
import { userService } from '@/services/user.service'
import { onMounted, ref, computed } from 'vue'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import { useStore } from 'vuex'

interface CuponResponse {
  codigo: string
  store_url: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TheCuponesTienda',
  props: {
    id: null,
    nombre: null
  },
  setup(__props: any) {

const props = __props as {
  id: number
  nombre: string
};

const { getters } = useStore<VuexStore>(key)



const loading = ref(false)

const cuponesDisponibles = ref(false) 

const cupon = ref()
const url = ref()
const mensajeCupon = ref<string | undefined>(undefined)


const miCupon = async () => {
  const response = await userService.misCuponPorActividad(props.id)
  const { codigo, store_url } = response as CuponResponse
  cupon.value = codigo
  url.value = store_url
}

const hayCuponesDisponibles = async () => {
  cuponesDisponibles.value = await cuponesService.hayCuponesDisponibles(
    props.id
  )
}


const obtenerCupon = async () => {
  loading.value = true
  const {
    codigo,
    store_url,
  } = await cuponesService.obtenerCupon(props.id) as CuponResponse
  cupon.value = codigo
  url.value = store_url
  loading.value = false
}

const mostrarCuponConBorder = computed(() => {
  return !!cupon.value && url.value && url.value !== '--'
})

onMounted(async () => {
  loading.value = true
  if (getters.isLogin) {
    await miCupon()
    if (!cupon.value) {
      await hayCuponesDisponibles()
    }
  }
  loading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-none d-lg-block col-12 mb-5", { 'cupon-border': _unref(mostrarCuponConBorder) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (mensajeCupon.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(mensajeCupon.value), 1)
          ]))
        : (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : (!cupon.value && !cuponesDisponibles.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            : (!cupon.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("h5", _hoisted_11, " Obtené tu beneficio exclusivo de " + _toDisplayString(props.nombre) + " desde el siguiente botón ", 1),
                  _createElementVNode("button", {
                    class: "btn btn-primary px-4 py-2 text-uppercase",
                    type: "button",
                    onClick: obtenerCupon
                  }, " Quiero mi beneficio ")
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  (url.value && url.value ==='--')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("h6", _hoisted_12, " Para obtener este beneficio de " + _toDisplayString(props.nombre) + " serás contactado por un concesionario oficial en un lapso de 10 días. ", 1),
                        _createElementVNode("h6", _hoisted_13, " ¡Seguí navegando la web " + _toDisplayString(_ctx.state.evento?.nombre) + " para enterarte de todos los beneficios que te dá ser miembro de la comunidad! ", 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("h4", _hoisted_16, _toDisplayString(cupon.value), 1),
                        (url.value)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: url.value,
                              target: "_blank"
                            }, _hoisted_19, 8, _hoisted_17))
                          : _createCommentVNode("", true),
                        _hoisted_20,
                        _hoisted_21
                      ]))
                ], 64))
    ])
  ], 2))
}
}

})